import React from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Calendar, User, ArrowRight, Users, GraduationCap, PartyPopper } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function BlogPage() {
  const posts = [{
    id: 4,
    title: 'Retour sur le 1er Atelier National ADCC : 41 participants, 8 modules, une ambition',
    excerpt: "Du 12 au 14 mars 2026, l'ADCC a organisé son tout premier atelier national de renforcement des capacités dédié aux métiers de l'entretien et de la maintenance, réunissant 41 participants. Un événement fondateur avec le soutien de la Mairie de Cotonou, Care International et bien d'autres partenaires.",
    date: '16 Mar 2026',
    author: 'Équipe ADCC',
    category: 'Formation',
    image: 'https://cdn.magicpatterns.com/uploads/opPxzmWiMSRTC4qTrQ2YSj/WhatsApp_Image_2026-03-16_at_14.07.52_(3).jpg',
    featured: true,
    content: `
        <p>Du 12 au 14 mars, l'ADCC a organisé son tout premier atelier national de renforcement des capacités dédié aux métiers de l'entretien et de la maintenance, réunissant 41 participants autour d'un objectif clair : professionnaliser un secteur à fort potentiel d'emploi au Bénin.</p>

        <h3>Lancement officiel à l'hôtel Azalaï de Cotonou</h3>
        <p>Le lancement officiel s'est tenu le 12 mars à l'hôtel Azalaï de Cotonou, en présence de plusieurs acteurs institutionnels et partenaires clés, notamment la Mairie de Cotonou, Care International Bénin, l'Institut National de la Femme, ainsi que des structures de placement telles que O2 Bénin et Wiston Services. Cette cérémonie a permis de présenter la vision et les ambitions de l'ADCC, de sensibiliser à l'importance de structurer les métiers de services et de renforcer les synergies entre les acteurs de l'emploi et de l'insertion professionnelle.</p>

        <h3>Deux journées de formation intensive à Bamboo Numérique</h3>
        <p>Les 13 et 14 mars, les activités se sont poursuivies à Bamboo Numérique dans une ambiance dynamique, participative et conviviale. Les participants ont bénéficié d'une formation intensive articulée autour de huit modules complémentaires, animés par des experts engagés :</p>
        <ul>
          <li><strong>Nettoyage professionnel</strong> – Mahambi Moussa</li>
          <li><strong>Entretien des vêtements et textiles</strong> – Gisèle ATCHADE</li>
          <li><strong>Rangement et organisation</strong> – Bill Isaac AGBANGLA</li>
          <li><strong>Droits et devoirs du travailleur</strong> – Jean Apôtre OBOSSOU</li>
          <li><strong>Attitude et comportement professionnel</strong> – Fidèle ADJOVI</li>
          <li><strong>Gestion de carrière et recherche d'emploi</strong> – Arthur FREUD SEGNON</li>
          <li><strong>Conception de CV et pitch professionnel</strong> – Serge KOUOH</li>
          <li><strong>Sensibilisation aux violences faites aux femmes</strong> – Maître ATADE TOPANOU</li>
        </ul>
        <p>Cette diversité de contenus a permis d'aborder à la fois les compétences techniques, les compétences comportementales et les enjeux sociaux liés à ces métiers, avec une approche résolument pratique et orientée terrain.</p>

        <h3>Un tremplin vers l'employabilité</h3>
        <p>Au-delà des apprentissages, cet atelier visait à renforcer l'employabilité des participants, à valoriser des métiers essentiels mais encore insuffisamment reconnus, et à créer une dynamique de réseau entre bénéficiaires et partenaires.</p>
        <p>À l'issue des deux journées de formation, les participants ont reçu une attestation de participation, marquant la reconnaissance de leur engagement et le début d'un parcours de professionnalisation.</p>

        <h3>Les bases d'une action structurante</h3>
        <p>À travers cette initiative, l'ADCC pose les bases d'une action structurante pour le développement des métiers de l'entretien au Bénin, avec l'ambition de professionnaliser et insérer durablement les talents locaux.</p>
      `
  }, {
    id: 1,
    title: "Forum Fondateur : L'ADCC à l'écoute des personnels de maison",
    excerpt: 'Retour sur notre tout premier événement qui a réuni une dizaine de personnels de maison de différents domaines. Une rencontre fondatrice qui a permis de cartographier les besoins réels et de poser les bases de notre action.',
    date: '10 Jan 2026',
    author: 'Équipe ADCC',
    category: 'Article',
    image: 'https://cdn.magicpatterns.com/uploads/exRoSvgKroC4rrK6KpbESt/WhatsApp_Image_2026-01-29_at_17.21.09.jpg',
    featured: false,
    content: `
        <p>L'Association Dignité Compétence Création (ADCC) a organisé son tout premier forum d'état des lieux, réunissant une dizaine de personnels de maison venus de différents horizons professionnels : entretien ménager, cuisine, garde d'enfants, gardiennage...</p>
        
        <h3>Une démarche d'écoute avant tout</h3>
        <p>Avant de lancer nos programmes de formation, nous avons voulu comprendre. Comprendre les réalités quotidiennes, les difficultés rencontrées, les aspirations de celles et ceux que nous souhaitons accompagner.</p>
        
        <h3>Ce que nous avons appris</h3>
        <ul>
          <li><strong>Un besoin réel en compétences professionnelles</strong> : Beaucoup exercent sans avoir reçu de formation structurée, apprenant "sur le tas".</li>
          <li><strong>Une demande de reconnaissance</strong> : Les métiers de service à la personne souffrent d'un manque de considération sociale.</li>
          <li><strong>L'importance de l'accompagnement</strong> : Trouver un emploi est une chose, le garder dans de bonnes conditions en est une autre.</li>
        </ul>
        
        <h3>Les prochaines étapes</h3>
        <p>Ce forum a posé les fondations de notre approche : écouter d'abord, agir ensuite. Les enseignements tirés de cette rencontre guident aujourd'hui la conception de nos ateliers de formation prévus pour mars 2026.</p>
        
        <p>Merci à tous les participants qui ont accepté de partager leur vécu avec nous. Ensemble, nous construisons un avenir plus digne pour les personnels de maison au Bénin.</p>
      `
  }, {
    id: 3,
    title: 'Festival des Personnels de Maison - Juin 2026 : Save the Date !',
    excerpt: 'Un événement unique au Bénin célébrant la dignité et les compétences des personnels de maison. Au programme : célébrations culturelles, témoignages inspirants, espace recrutement et networking. Rejoignez-nous !',
    date: '20 Jan 2026',
    author: 'Équipe ADCC',
    category: 'Événement',
    image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    featured: false,
    content: `
        <p>L'ADCC est fière d'annoncer l'organisation du tout premier Festival des Personnels de Maison au Bénin ! Un événement inédit qui célèbrera la dignité, les compétences et la contribution essentielle de ces travailleurs souvent invisibles.</p>
        
        <h3>Pourquoi ce festival ?</h3>
        <p>Les personnels de maison – femmes de ménage, cuisiniers, nounous, gardiens, chauffeurs – sont indispensables au fonctionnement de nombreux foyers et entreprises. Pourtant, leur travail reste peu reconnu et valorisé. Ce festival veut changer le regard de la société.</p>
        
        <h3>Au programme</h3>
        <ul>
          <li><strong>Célébrations culturelles</strong> : Musique, danse et expressions artistiques mettant à l'honneur ces métiers.</li>
          <li><strong>Témoignages inspirants</strong> : Des parcours de vie, des réussites, des histoires qui donnent espoir.</li>
          <li><strong>Espace de rencontres professionnelles</strong> : Un lieu d'échange entre personnels formés et employeurs responsables.</li>
          <li><strong>Ateliers de networking et speed-meeting</strong> : Créez des connexions, trouvez des opportunités.</li>
          <li><strong>Présentation de profils qualifiés</strong> : Les bénéficiaires de nos formations pourront se présenter aux employeurs partenaires.</li>
        </ul>
        
        <h3>Un événement ouvert à tous</h3>
        <p>Que vous soyez personnel de maison, employeur, partenaire institutionnel ou simplement curieux, vous êtes les bienvenus ! Le festival est gratuit et ouvert au public.</p>
        
        <h3>Comment participer ?</h3>
        <p>Inscrivez-vous dès maintenant via notre page "Nos Actions". Vous pouvez participer en tant que visiteur, exposant, témoin ou recruteur.</p>
        
        <p><strong>Juin 2026 : Ensemble, célébrons la dignité du travail !</strong></p>
      `
  }];
  const featuredPost = posts.find(p => p.featured);
  const articlePosts = posts.filter(p => !p.featured && p.category !== 'Événement');
  const eventPosts = posts.filter(p => !p.featured && p.category === 'Événement');
  return <Layout data-id="element-930">
      <SEO {...pageSEO.blog} data-id="element-931" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-932">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-933">
          <h1 className="text-4xl font-bold mb-4" data-id="element-934">Actualités ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-935">
            Suivez nos avancées, découvrez nos événements et restez informés de
            notre action pour l'insertion professionnelle digne.
          </p>
        </div>
      </div>

      {/* Featured Article */}
      {featuredPost && <section className="py-12 bg-white" data-id="element-936">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-937">
            <div className="mb-8" data-id="element-938">
              <span className="inline-flex items-center gap-2 bg-[#1E88E5]/10 text-[#1E88E5] px-4 py-2 rounded-full text-sm font-semibold" data-id="element-939">
                <Users className="w-4 h-4" data-id="element-940" />
                Article à la une
              </span>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-941">
              <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-942">
                <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-[400px] object-cover" data-id="element-943" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold text-[#1E88E5] uppercase tracking-wide" data-id="element-944">
                  {featuredPost.category}
                </div>
              </div>

              <div className="lg:pl-8" data-id="element-945">
                <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4" data-id="element-946">
                  <div className="flex items-center" data-id="element-947">
                    <Calendar className="w-4 h-4 mr-2" data-id="element-948" />
                    {featuredPost.date}
                  </div>
                  <div className="flex items-center" data-id="element-949">
                    <User className="w-4 h-4 mr-2" data-id="element-950" />
                    {featuredPost.author}
                  </div>
                </div>

                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-951">
                  {featuredPost.title}
                </h2>

                <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-952">
                  {featuredPost.excerpt}
                </p>

                <Link to={`/blog/article/${featuredPost.id}`} data-id="element-953">
                  <Button className="gap-2" data-id="element-954">
                    Lire la suite
                    <ArrowRight className="w-4 h-4" data-id="element-955" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>}

      {/* Blog Articles - Landscape layout */}
      {articlePosts.length > 0 && <section className="py-16 bg-gray-50" data-id="element-956">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-957">
            <div className="mb-10" data-id="element-958">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-959">Nos articles</h2>
              <p className="text-gray-600 mt-2" data-id="element-960">
                Retour sur nos actions et réflexions
              </p>
            </div>

            <div className="space-y-12" data-id="element-961">
              {articlePosts.map(post => <div key={post.id} className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-962">
                  <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-963">
                    <img src={post.image} alt={post.title} className="w-full h-[350px] object-cover" data-id="element-964" />
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold text-[#1E88E5] uppercase tracking-wide" data-id="element-965">
                      {post.category}
                    </div>
                  </div>

                  <div className="lg:pl-8" data-id="element-966">
                    <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4" data-id="element-967">
                      <div className="flex items-center" data-id="element-968">
                        <Calendar className="w-4 h-4 mr-2" data-id="element-969" />
                        {post.date}
                      </div>
                      <div className="flex items-center" data-id="element-970">
                        <User className="w-4 h-4 mr-2" data-id="element-971" />
                        {post.author}
                      </div>
                    </div>

                    <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4" data-id="element-972">
                      {post.title}
                    </h2>

                    <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-973">
                      {post.excerpt}
                    </p>

                    <Link to={`/blog/article/${post.id}`} data-id="element-974">
                      <Button className="gap-2" data-id="element-975">
                        Lire la suite
                        <ArrowRight className="w-4 h-4" data-id="element-976" />
                      </Button>
                    </Link>
                  </div>
                </div>)}
            </div>
          </div>
        </section>}

      {/* Événements à venir */}
      {eventPosts.length > 0 && <section className="py-16 bg-white" data-id="element-977">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-978">
            <div className="mb-10" data-id="element-979">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-980">
                Événements à venir
              </h2>
              <p className="text-gray-600 mt-2" data-id="element-981">
                Nos prochaines actions pour 2026
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-982">
              {eventPosts.map(post => <Card key={post.id} className="flex flex-col h-full overflow-hidden hover:shadow-lg transition-shadow duration-300 bg-white border" data-id="element-983">
                  <div className="h-56 overflow-hidden relative" data-id="element-984">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-985" />
                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-[#1E88E5] uppercase tracking-wide flex items-center gap-1" data-id="element-986">
                      <PartyPopper className="w-3 h-3" data-id="element-987" />
                      {post.category}
                    </div>
                  </div>
                  <CardContent className="flex-grow p-6 flex flex-col" data-id="element-988">
                    <div className="flex items-center text-gray-400 text-sm mb-3 space-x-4" data-id="element-989">
                      <div className="flex items-center" data-id="element-990">
                        <Calendar className="w-4 h-4 mr-1" data-id="element-991" />
                        {post.date}
                      </div>
                      <div className="flex items-center" data-id="element-992">
                        <User className="w-4 h-4 mr-1" data-id="element-993" />
                        {post.author}
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2" data-id="element-994">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-6 line-clamp-3 flex-grow" data-id="element-995">
                      {post.excerpt}
                    </p>
                    <Link to="/actions#inscription" data-id="element-996">
                      <Button variant="secondary" className="w-full gap-2" data-id="element-997">
                        Participer au festival
                        <ArrowRight className="w-4 h-4" data-id="element-998" />
                      </Button>
                    </Link>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </section>}

      {/* Facebook Post */}
      <section className="py-16 bg-white" data-id="element-999">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1000">
          <div className="mb-8 text-center" data-id="element-1001">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-1002">
              Sur nos réseaux
            </h2>
            <p className="text-gray-600 mt-2" data-id="element-1003">Retrouvez-nous sur Facebook</p>
          </div>
          <div className="flex justify-center" data-id="element-1004">
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02n1Xano2gvsx7CznAh2Z9poPkiB3RL2hgSMS5FiC97NHH4QXvbmgGcwXgufQjqCG8l%26id%3D100087364816701&show_text=true&width=500" width="500" height="250" style={{
            border: 'none',
            overflow: 'hidden'
          }} scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" title="Post Facebook ADCC" data-id="element-1005" />
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="py-16 bg-gray-50" data-id="element-1006">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1007">
          <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] rounded-2xl p-8 md:p-12 text-white" data-id="element-1008">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1009">
              Restez informés de nos actualités
            </h2>
            <p className="text-blue-100 mb-8" data-id="element-1010">
              Suivez-nous sur les réseaux sociaux pour ne rien manquer de nos
              événements et de notre action.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1011">
              <a href="https://www.facebook.com/profile.php?id=61587454706476" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-white text-[#1E88E5] font-semibold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1012">
                Facebook
              </a>
              <a href="https://www.linkedin.com/company/association-dignit%C3%A9-comp%C3%A9tence-cr%C3%A9ation-adcc" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-white/20 text-white font-semibold rounded-lg hover:bg-white/30 transition-colors border border-white/30" data-id="element-1013">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}